/* Wagbowl — food checker core. ONE OWNER for "how worried should I be?" and the "They already ate it"
   panel. Used by sections/wb-checker-hub (the search page) and sections/wb-checker-answer (every food's
   own page). Neither section carries its own copy of this logic — a second copy is a bug even while
   it agrees (CLAUDE.md §1).

   ⚠ "CALL A VET" IS DECIDED BY THE RESULT, NEVER THE VERDICT (Kevan, 12 Oct 2026): a bite of pizza,
   chai or paratha must not say "call your vet", and those dishes stay `never` — they are food.
     careful + mild (plain roti)          → watch at home at any amount
     never   + mild (pizza, biryani, chai) → a bite / a few mouthfuls = watch, a plate = call today
     dose_threshold in g/kg (garlic, onion, salt, macadamia) → grams ÷ kg against the entry's own figure
     chocolate                             → theobromine mg/kg by type, Merck bands (20 / 60)
     hazard zero, or a mg/kg-only threshold (grapes, xylitol, Panadol) → go now at any amount
   The red button appears only for "call today" / "go now", and only when the theme has a vet link
   (Theme settings → Wagbowl contact → Find a vet link). With none it is simply absent — a button to
   nowhere is worse than no button.

   Entry shape (both sections emit it): { h, name, verdict, hazard, thr, unit, amount, why, if_eaten, watch }
   Config shape (snippets/wb-checker-config): { wa: "https://wa.me/…", vet: "" }
   No animation anywhere: these are safety figures (Bible §5 — never animate what the user must obey). */
(function () {
  if (window.WBC) return;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var MATRIX = { zero: { bite: 'now', little: 'now', lot: 'now' }, dose: { bite: 'watch', little: 'today', lot: 'now' },
                 physical: { bite: 'today', little: 'now', lot: 'now' }, mild: { bite: 'watch', little: 'watch', lot: 'today' } };
  var AMTS = [['bite', 'A bite or two', 'off a plate'], ['little', 'A few mouthfuls', 'a small amount'], ['lot', 'A lot', 'a portion or more']];
  var CTYPES = [['White', 0.25], ['Milk', 2.4], ['Dark', 5.5], ['Baking', 16], ['Cocoa', 20]];
  var LV = {
    fine: ['Nothing to worry about', 'This is fine for dogs. If they ate a lot of it, expect a soft stool at most.'],
    watch: ['Watch at home', 'Not an emergency at this amount. Keep water out and watch them for 24 hours. Call your vet if anything changes, sooner for a small or older dog.'],
    today: ['Call your vet today', 'Worth a phone call, not a panic. Tell them what and how much. They may say watch at home, but that should be their call.'],
    now: ['Go to a vet now', 'Treat this as an emergency. Take the packet or a photo. Don’t wait for signs, and don’t make them vomit unless a vet tells you to.']
  };

  function isChoc(f) { return f.h === 'chocolate'; }
  function gramRule(f) { return f.thr && f.unit === 'g_per_kg'; }
  function needs(f) {
    if (f.verdict === 'safe' || f.hazard === 'zero' || (f.thr && f.unit !== 'g_per_kg')) return '';
    return (isChoc(f) || gramRule(f)) ? 'grams' : 'amt';
  }
  function urgency(f, o) {
    o = o || {};
    if (f.verdict === 'safe') return { lvl: 'fine' };
    if (f.hazard === 'zero' || (f.thr && f.unit !== 'g_per_kg')) return { lvl: 'now', line: 'Any amount counts with this one.' };
    if (isChoc(f) && o.g > 0 && o.kg > 0) {
      var d = o.g * (o.conc || 2.4) / o.kg;
      return { lvl: d < 20 ? 'watch' : d < 60 ? 'today' : 'now', line: d.toFixed(0) + ' mg per kg of theobromine. Signs start around 20, serious from 60 (Merck).' };
    }
    if (gramRule(f) && o.g > 0 && o.kg > 0) {
      var r = o.g / o.kg;
      return { lvl: r >= f.thr ? 'now' : r >= f.thr / 3 ? 'today' : 'watch',
               line: r.toFixed(1) + ' g per kg. Problems are reported from about ' + f.thr + ' g per kg (' + Math.round(f.thr * o.kg) + ' g for your dog).' };
    }
    if (o.amt && f.hazard === 'mild' && f.verdict === 'careful') return { lvl: 'watch' };
    if (o.amt) return { lvl: (MATRIX[f.hazard] || MATRIX.mild)[o.amt] };
    return null;
  }
  function levelHTML(f, u, cfg) {
    var t = LV[u.lvl], urgent = u.lvl === 'today' || u.lvl === 'now', b = '';
    if (urgent && cfg && cfg.vet) b += '<a class="wbc-btn is-call" href="' + esc(cfg.vet) + '">' + (u.lvl === 'now' ? 'Call a vet now' : 'Call a vet today') + '</a>';
    if (u.lvl !== 'fine' && cfg && cfg.wa) b += '<a class="wbc-btn" href="' + esc(cfg.wa) + '?text=' + encodeURIComponent('My dog ate ' + f.name + ' — can you help?') + '" target="_blank" rel="noopener">Ask us on WhatsApp</a>';
    return '<div class="wbc-lvl is-' + u.lvl + '"><b>' + t[0] + '</b>' + (u.line ? esc(u.line) + ' ' : '') + t[1] + (b ? '<div class="wbc-btns">' + b + '</div>' : '') + (urgent && cfg && cfg.vet && cfg.vetName ? '<p class="wbc-vetname">' + esc(cfg.vetName) + '</p>' : '') + '</div>';
  }
  function giveHTML(f) {
    var h = '';
    if (f.amount) h += '<div class="wbc-kv"><b>' + (f.verdict === 'never' ? 'Why not even a little' : 'How much is fine') + '</b>' + esc(f.amount) + '</div>';
    if (f.why) h += '<div class="wbc-kv"><b>Why</b>' + esc(f.why) + '</div>';
    return h;
  }
  function kvHTML(f) {
    var h = '';
    if (f.if_eaten) h += '<div class="wbc-kv"><b>If they ate it</b>' + esc(f.if_eaten) + '</div>';
    if (f.watch) h += '<div class="wbc-kv"><b>Watch for</b>' + esc(f.watch) + '</div>';
    return h;
  }
  /* The interactive part of "They already ate it": the question (if the answer needs one) and the
     result. opts.kv = true also writes "If they ate it / Watch for" — the food page renders those
     server-side instead, so they read without JS. */
  function atePanel(box, f, cfg, opts) {
    opts = opts || {};
    var st = { amt: null, g: null, kg: null, conc: 2.4 }, n = needs(f), h = '';
    if (n === 'amt') h += '<p class="wbc-q">How much did they eat?</p><div class="wbc-amts">' + AMTS.map(function (a) {
      return '<button type="button" class="wbc-amt" data-a="' + a[0] + '" aria-pressed="false">' + a[1] + '<small>' + a[2] + '</small></button>'; }).join('') + '</div>';
    if (n === 'grams') {
      if (isChoc(f)) h += '<p class="wbc-q">What kind?</p><div class="wbc-cts">' + CTYPES.map(function (c) {
        return '<button type="button" class="wbc-ct" data-c="' + c[1] + '" aria-pressed="' + (c[1] === 2.4) + '">' + c[0] + '</button>'; }).join('') + '</div>';
      h += '<p class="wbc-q">How much, and how big is your dog?</p><div class="wbc-gk">' +
        '<label>Ate about<span class="wbc-in"><input type="number" inputmode="decimal" min="0" data-k="g" placeholder="e.g. 5"><i>g</i></span></label>' +
        '<label>Dog weighs<span class="wbc-in"><input type="number" inputmode="decimal" min="0" data-k="kg" placeholder="e.g. 12"><i>kg</i></span></label></div>';
    }
    h += '<div data-wbc-lvl></div>';
    if (opts.kv) h += kvHTML(f);
    box.innerHTML = h;
    function lvl() { var u = urgency(f, st), el = box.querySelector('[data-wbc-lvl]'); if (el) el.innerHTML = u ? levelHTML(f, u, cfg) : ''; }
    box.addEventListener('click', function (e) {
      var a = e.target.closest('.wbc-amt'); if (a) { st.amt = a.getAttribute('data-a');
        box.querySelectorAll('.wbc-amt').forEach(function (x) { x.setAttribute('aria-pressed', String(x === a)); }); lvl(); return; }
      var c = e.target.closest('.wbc-ct'); if (c) { st.conc = parseFloat(c.getAttribute('data-c'));
        box.querySelectorAll('.wbc-ct').forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); }); lvl(); }
    });
    box.addEventListener('input', function (e) { var i = e.target.closest('[data-k]'); if (i) { st[i.getAttribute('data-k')] = parseFloat(i.value) || null; lvl(); } });
    lvl();
  }
  window.WBC = { esc: esc, needs: needs, urgency: urgency, levelHTML: levelHTML, giveHTML: giveHTML, kvHTML: kvHTML, atePanel: atePanel };
})();
